import { withStyles } from '@material-ui/core/styles';
import FormGroup from '@material-ui/core/FormGroup';

export default withStyles({
    root: {
        flexWrap: 'nowrap',
        marginBottom: 24,
        '& > *': {
            marginRight: 16,
            flex: 1,
        },
        '&:empty': {
            display: 'none',
        },
        '& > .MuiFormGroup-row': {
            marginBottom: 0,
        },
        '& > :last-child': {
            marginRight: 0,
        },
        '&:last-child': {
            marginBottom: 0,
        },
    },
}, { name: 'CustomFormGroup' })(FormGroup);